import KioskQrDialog from "./kiosk-qr-dialog.vue";

const loadPromise = new Promise(resolve => {
  vueApp.component('kiosk-qr-dialog', KioskQrDialog);
  resolve();
});

window.pendingComponentLoads.push(loadPromise);
